const Constants = {
  ITEMS_PER_PAGE: 10,
  STATUS: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
  },
  ROLES: {
    ADMIN: 'admin',
    USER: 'user',
  },
  TRANSACTIONS: {
    ACCOUNT_TYPE: {
      CORPORATE: 'corporate',
      ESCROW: 'escrow'
    },
    BUSINESS_STATUS: {
      INHOUSE: 'inhouse',
      CLIENT: 'client'
    },
    // Keeping STATUS for backward compatibility during migration
    STATUS: {
      INHOUSE: 'inhouse',
      CLIENT: 'client'
    }
  },
  DOCUMENT_CATEGORIES: {
    INVOICE: 'invoice',
    COMPANY_DOC: 'company_doc',
    SCREENSHOT: 'screenshot',
    CONTRACT: 'contract',
    RECEIPT: 'receipt',
    OTHER: 'other'
  },
  APPROVAL_STATUS: {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected'
  },
  TRANSACTION_TYPES: {
    PAYMENT: 'payment',
    INSTALLMENT: 'installment'
  }
}

export default Constants
